import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'

export default class Servicenowadmintemplate extends Component {
  render() {
    const course = [
      {
        title: "Administration Basics",
        content: [
        "Introduction to ServiceNow platform",
        "ServiceNow navigation and user interface",
        "Setting up and managing users and groups",
        "Configuring access controls and permissions",
        "Working with forms and fields",
        "Creating tables and defining relationships",
        "Introduction to scripting in ServiceNow"
        ]
        },
        {
        title: "Data Management",
        content: [
        "Importing and exporting data",
        "Creating and managing data sources",
        "Data policies and data imports",
        "Using transform maps",
        "Using web services and REST APIs",
        "Using ServiceNow reporting and analytics"
        ]
        },
        {
        title: "Incident Management",
        content: [
        "Incident management process overview",
        "Creating and managing incidents",
        "SLA and OLA management",
        "Incident escalation and resolution",
        "Using ServiceNow collaboration tools",
        "Incident management reporting and analytics"
        ]
        },
        {
        title: "Problem Management",
        content: [
        "Problem management process overview",
        "Creating and managing problems",
        "Problem investigation and diagnosis",
        "Problem resolution and closure",
        "Using ServiceNow collaboration tools",
        "Problem management reporting and analytics"
        ]
        },
        {
        title: "Change Management",
        content: [
        "Change management process overview",
        "Creating and managing changes",
        "Change assessment and approval",
        "Implementing and verifying changes",
        "Using ServiceNow collaboration tools",
        "Change management reporting and analytics"
        ]
        },
        {
        title: "Service Catalog Management",
        content: [
        "Service catalog management overview",
        "Creating and managing catalog items and categories",
        "Service request management",
        "Using workflows to automate service requests",
        "Using ServiceNow collaboration tools",
        "Service catalog management reporting and analytics"
        ]
        },
        {
        title: "Service Level Management",
        content: [
        "Service level management overview",
        "Creating and managing service level agreements (SLAs)",
        "SLA workflow and automation",
        "Service level reporting and analytics",
        "Using ServiceNow collaboration tools"
        ]
        },
        {
        title: "Configuration Management",
        content: [
        "Configuration management overview",
        "CI identification and tracking",
        "CI relationships and dependencies",
        "Configuring and managing ServiceNow discovery",
        "Using ServiceNow collaboration tools",
        "Configuration management reporting and analytics"
        ]
        },
        {
        title: "Asset Management",
        content: [
        "Asset management overview",
        "Creating and managing assets",
        "Managing asset life cycle",
        "Software asset management",
        "Using ServiceNow collaboration tools",
        "Asset management reporting and analytics"
        ]
        },
        {
        title: "Service Portal",
        content: [
        "Service portal overview",
        "Configuring and customizing service portal",
        "Creating and managing widgets",
        "Service portal scripting and automation",
        "Using ServiceNow collaboration tools",
        "Service portal reporting and analytics"
        ]
        },
        {
        title: "Performance Analytics",
        content: [
        "Performance analytics overview",
        "Creating and managing scorecards",
        "Creating and managing indicators",
        "Creating and managing breakdowns",
        "Performance analytics reporting and analytics",
        "Using ServiceNow collaboration tools"
        ]
        },
    ]

    const faqData = [
      {
        question: 'What is ServiceNow Admin?',
        answer:
          'ServiceNow Admin refers to professionals who manage, configure, and customize the ServiceNow platform to meet an organization\'s needs',
      },
      {
        question: 'What are the key responsibilities of a ServiceNow Admin?',
        answer:
          "ServiceNow Admins are responsible for tasks like user management, application customization, system maintenance, and ensuring smooth operations of the ServiceNow platform",
      },
      {
        question: 'How can I become a certified ServiceNow Admin?',
        answer:
          'To become a certified ServiceNow Admin, you can enroll in training programs offered by reputed institutions like [Best Training Centre]. These programs cover all aspects of ServiceNow administration and prepare you for certification exams',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'ServiceNow Admins can explore various career opportunities such as ServiceNow Consultant, ServiceNow Developer, IT Service Manager, IT Operations Manager, ServiceNow Architect, and ServiceNow Project Manager. They can also advance their careers by pursuing specialized certifications and expanding their knowledge in specific ServiceNow modules.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Uncover the Eligibility Requirements at our esteemed learning institute for mastering ServiceNow administration, a pivotal role in managing and optimizing ServiceNow platforms for organizational efficiency. As the top training center in the industry, we offer comprehensive courses meticulously designed to equip you with the requisite skills and expertise needed to excel as a ServiceNow administrator. Whether you're a seasoned IT professional seeking to expand your skill set or an aspiring newcomer to the field, our seasoned instructors will guide you through immersive training sessions, hands-on practical exercises, and real-world scenarios. Join us and embark on your journey to becoming a proficient ServiceNow administrator with confidence and prowess, setting the stage for a successful career in ServiceNow administration"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]

    return (
      <>
      
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of modern IT operations, proficiency in managing and administering ServiceNow instances is a prized skillset. Enter the ServiceNow Admin course, a meticulously designed training program crafted to equip individuals with the essential skills and knowledge needed to navigate and optimize ServiceNow environments. This comprehensive course encompasses a wide spectrum of crucial topics, ranging from ServiceNow architecture to user management, data administration, service catalog management, and reporting." /> */}
          
          <NewMainsec rating='4.5' students={"436"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the dynamic landscape of modern IT operations, proficiency in managing and administering ServiceNow instances is a prized skillset. Enter the ServiceNow Admin course, a meticulously designed training program crafted to equip individuals with the essential skills and knowledge needed to navigate and optimize ServiceNow environments. This comprehensive course encompasses a wide spectrum of crucial topics, ranging from ServiceNow architecture to user management, data administration, service catalog management, and reporting."/>

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
           <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`ServiceNow is a popular platform that enables businesses to streamline their operations and enhance their overall productivity. At Learnsoft.org, we offer top-notch ServiceNow admin training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of ServiceNow principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to ServiceNow or looking to expand your skillset, Learnsoft.org's ServiceNow admin ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your ServiceNow journey.`}
              title={this.props.title} location={this.props.location} course={"Our ServiceNow admin course covers a wide range of topics, including ServiceNow architecture, user interface, data management, and reporting. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in ServiceNow administration. By the end of the course, you will be able to implement ServiceNow practices in your own projects."} />
          </section>
          <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
           <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>    
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Scrum Master" coupath7="scrum-master" cou1='ServiceNow' coupath1='servicenow' cou6='Pega' coupath6='pega' cou10='PowerApps' coupath10='powerapps' cou4='Jira' coupath4='jira-admin' 
          cou5='Endpoint Manager' coupath5='endpoint-manager' cou8='Dynamic365' coupath8='dynamic365' cou='ITSM' coupath='itsm' cou2='Okta' coupath2='okta' cou9='Mulesoft' coupath9='mulesoft'  cou3='SAP' coupath3='sap'/>
   
        
      </>
    );
  }
}
